export const FEATURE_NAME = '@zerops/zerops/common/user-data-form-field/modules/user-data-env-format-dialog';
